<div class="page-header--container white--curve" [ngStyle]="pageHeaderStyle">
    <div class="content--wrapper">
        <a [routerLink]="['/FundRecommend','option3']">
            <i class="fas fa-chevron-left"></i>
            <span>{{language.backfundrecom}}</span>
        </a>

        <div class="row">
            <div *ngIf="file_pdf == 'no'" class="col-12">
                <div #insertDotdotdot class="insert-dotdotdot col-12">
                    <h1 class="title insert-dotdotdot">{{vdoTitle}}</h1>
                </div>
                <div class="col-12">
                    <time *ngIf="flag == 'th'">{{vdoDate}}</time>
                    <time *ngIf="flag == 'en'">{{vdoDate | date:'dd MMMM yyyy'}}</time>
                </div>
            </div>

            <div *ngIf="file_pdf == 'yes'" class="col-8">
                <div #insertDotdotdot class="insert-dotdotdot col-12">
                    <h1 class="title insert-dotdotdot">{{vdoTitle}}</h1>
                </div>
                <div class="col-12">
                    <time *ngIf="flag == 'th'">{{vdoDate}}</time>
                    <time *ngIf="flag == 'en'">{{vdoDate | date:'dd MMMM yyyy'}}</time>
                </div>
            </div>

            <div *ngIf="file_pdf == 'yes'" class="col-4 text-right">
                <a href="{{pdfUrl_path}}" target="_blank" download>
                    <app-button style="margin-top: 32px;" text="{{language.funddetailthm4detail5}} {{filesize}}">
                    </app-button>
                </a>
            </div>
        </div>

    </div>
</div>
<section class="content-inner">
    <div class="container">
        <section class="content-detail">
            <div class="row">
                <div [ngSwitch]="vdoType" rel="layout-detail">
                    <div *ngSwitchCase="'text'">
                        <div *ngIf="flag == 'th'; else elsetext">
                            <div class="info" *ngFor="let item of showvdo" [innerHTML]="item.detail">
                            </div>
                        </div>
                        <ng-template #elsetext>
                            <div class="info" *ngFor="let item of showvdo" [innerHTML]="item.detail_en">
                            </div>
                        </ng-template>
                    </div>
                    <div *ngSwitchCase="'image'">
                        <div *ngIf="flag == 'th'; else elseimage">
                            <div class="info" *ngFor="let item of showvdo">
                                <img src="{{item.detail}}" alt="">
                            </div>
                        </div>
                        <ng-template #elseimage>
                            <div class="info" *ngFor="let item of showvdo">
                                <img src="{{item.detail_en}}" alt="">
                            </div>
                        </ng-template>
                    </div>
                    <div *ngSwitchCase="'vdo'">
                        <div class="info" *ngFor="let item of showvdo">
                            <youtube-player [videoId]="id" (ready)="savePlayer($event)" (change)="onStateChange($event)"
                                width="100%" height="800px">
                            </youtube-player>
                        </div>
                    </div>
                    <div *ngSwitchDefault>
                        <div class="info" *ngFor="let item of showvdo" style="height: 800px">
                            <embed [src]="pdfUrl" type="application/pdf" width="100%" height="100%">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</section>